const steps = [
  '金融機関選択',
  '支店選択',
  '確認'
];

const getVoicedAndSemiVoicedSounds: (hiragana: string) => string[] = (hiragana) => {
  const voicedSounds: { [key: string]: string } = {
    "か": "が", "き": "ぎ", "く": "ぐ", "け": "げ", "こ": "ご",
    "さ": "ざ", "し": "じ", "す": "ず", "せ": "ぜ", "そ": "ぞ",
    "た": "だ", "ち": "ぢ", "つ": "づ", "て": "で", "と": "ど",
    "は": "ば", "ひ": "び", "ふ": "ぶ", "へ": "べ", "ほ": "ぼ"
  };

  const semiVoicedSounds: { [key: string]: string } = {
    "は": "ぱ", "ひ": "ぴ", "ふ": "ぷ", "へ": "ぺ", "ほ": "ぽ"
  };

  let result: string[] = [hiragana];

  if (voicedSounds[hiragana]) {
    result.push(voicedSounds[hiragana]);
  }

  if (semiVoicedSounds[hiragana]) {
    result.push(semiVoicedSounds[hiragana]);
  }

  return result;
};

export { steps, getVoicedAndSemiVoicedSounds };